import { configs } from './web.config.testnet'
import { ethers } from 'ethers'

export const getWeb3PRovider = () => {
  const { web3Config } = configs
  //initiate the web3 instance
  const web3 = new ethers.providers.JsonRpcProvider(web3Config.webRpcHttpNode, { name: 'binance', chainId: 97 })
  return web3
}

export const getBnbBalanceOfAddress = async (walletAddress) => {
  let walletBalanceInBNB = 0.00
  let walletBalanceInUSD = 0.00
  try {
    if (walletAddress) {
      const nativeBalance = await window.web3Instance.eth.getBalance(walletAddress)
      const actualBalance = nativeBalance / 10 ** 18
      const bnbPrice = await getBNBPrice()
      walletBalanceInUSD = parseFloat(bnbPrice) * parseFloat(actualBalance)
      walletBalanceInBNB = actualBalance

      return {
        walletBalanceInBNB,
        walletBalanceInUSD
      }

    } else {
      return {
        walletBalanceInBNB,
        walletBalanceInUSD
      }
    }
  } catch (error) {
    console.error("ERROR while fetching native balance of an address ", error)
    return {
      walletBalanceInBNB,
      walletBalanceInUSD
    }
  }
}

export const getBNBPrice = async () => {
  const { web3Config } = configs
  let amountOut = 0
  try {
    const contractAbi = JSON.parse(web3Config.pancakeSwapContractAbi)
    const pcsContract = await new window.web3Instance.eth.Contract(contractAbi, web3Config.pricingAddress.pancakeSwapContractAddress)
    const bnbToSell = window.web3Instance.utils.toWei('1', 'ether')
    amountOut = await pcsContract.methods.getAmountsOut(bnbToSell, [
      web3Config.pricingAddress.bnbTokenAddress,
      web3Config.pricingAddress.usdTokenAddress
    ])
      .call()
    amountOut = window.web3Instance.utils.fromWei(amountOut[1])
    return parseFloat(amountOut)
  } catch (error) {
    console.error("ERROR while fetching bnb price ", error)
    return 0.0
  }
}

export const getTotalStakedAmount = async () => {
  const { web3Config } = configs
  try {
    const minerContractABI = JSON.parse(web3Config.minerContractABI)
    const minerContractAddress = web3Config.minerContractAddress
    const minerContractInstance = await new window.web3Instance.eth.Contract(minerContractABI, minerContractAddress)
    const totalStakedAmountInWei = await minerContractInstance.methods.totalStaked().call()
    const totalStakedAmount = totalStakedAmountInWei / (10 ** 18)
    return totalStakedAmount
  } catch (error) {
    console.error("ERROR while fetching total staked amount in contract ", error)
    return 0.0
  }
}

export const getTotalRefBonus = async () => {
  const { web3Config } = configs
  try {
    const minerContractABI = JSON.parse(web3Config.minerContractABI)
    const minerContractAddress = web3Config.minerContractAddress
    const minerContractInstance = await new window.web3Instance.eth.Contract(minerContractABI, minerContractAddress)
    const totalRefAmountInWei = await minerContractInstance.methods.totalRefBonus().call()
    const totalRefAmount = totalRefAmountInWei / (10 ** 18)
    return totalRefAmount
  } catch (error) {
    console.error("ERROR while fetching total ref bonus amount in contract ", error)
    return 0.0
  }
}

export const getTotalContractBalance = async () => {
  const { web3Config } = configs
  try {
    const minerContractABI = JSON.parse(web3Config.minerContractABI)
    const minerContractAddress = web3Config.minerContractAddress
    const minerContractInstance = await new window.web3Instance.eth.Contract(minerContractABI, minerContractAddress)
    const totalContractBalanceInWei = await minerContractInstance.methods.getBalance().call()
    const totalContractBalance = totalContractBalanceInWei / (10 ** 18)
    return totalContractBalance
  } catch (error) {
    console.error("ERROR while fetching total contract balance ", error)
    return 0.0
  }
}

export const getTotalContractDragons = async () => {
  const { web3Config } = configs
  try {
    const minerContractABI = JSON.parse(web3Config.minerContractABI)
    const minerContractAddress = web3Config.minerContractAddress
    const minerContractInstance = await new window.web3Instance.eth.Contract(minerContractABI, minerContractAddress)
    const totalDragons = await minerContractInstance.methods.totalDeposits().call()
    return totalDragons
  } catch (error) {
    console.error("ERROR while fetching total dragons in contract ", error)
    return 0.0
  }
}

export const getDragonDetailsByUserAddress = async (address) => {

  let initialDeposit = 0.00
  let userDeposit = 0.00
  let miners = 0.00
  let claimEggs = 0.00
  let lastHatchTimestamp = 0
  let referrer = ''
  let referrals = 0
  let totalWithdrawn = 0.00
  let referralEggRewards = 0.00
  let dailyCompoundBonus = 0
  let farmerCompoundCount = 0
  let lastWithdrawTimestamp = 0

  const { web3Config } = configs
  if (address) {
    try {
      const minerContractABI = JSON.parse(web3Config.minerContractABI)
      const minerContractAddress = web3Config.minerContractAddress
      const minerContractInstance = await new window.web3Instance.eth.Contract(minerContractABI, minerContractAddress)
      const userDragonsDetails = await minerContractInstance.methods.getUserInfo(address).call()
      initialDeposit = userDragonsDetails[0] / (10 ** 18)
      userDeposit = userDragonsDetails[1] / (10 ** 18)
      miners = userDragonsDetails[2]
      claimEggs = userDragonsDetails[3] / (10 ** 18)
      lastHatchTimestamp = userDragonsDetails[4]
      referrer = userDragonsDetails[5]
      referrals = userDragonsDetails[6]
      totalWithdrawn = userDragonsDetails[7] / (10 ** 18)
      referralEggRewards = userDragonsDetails[8] / (10 ** 18)
      dailyCompoundBonus = userDragonsDetails[9]
      farmerCompoundCount = userDragonsDetails[10]
      lastWithdrawTimestamp = userDragonsDetails[11]

      return {
        initialDeposit,
        userDeposit,
        miners,
        claimEggs,
        lastHatchTimestamp,
        referrer,
        referrals,
        totalWithdrawn,
        referralEggRewards,
        dailyCompoundBonus,
        farmerCompoundCount,
        lastWithdrawTimestamp
      }
    } catch (error) {
      console.error("ERROR while fetching user dragons details ", error)
      return {
        initialDeposit,
        userDeposit,
        miners,
        claimEggs,
        lastHatchTimestamp,
        referrer,
        referrals,
        totalWithdrawn,
        referralEggRewards,
        dailyCompoundBonus,
        farmerCompoundCount,
        lastWithdrawTimestamp
      }
    }
  } else {
    return {
      initialDeposit,
      userDeposit,
      miners,
      claimEggs,
      lastHatchTimestamp,
      referrer,
      referrals,
      totalWithdrawn,
      referralEggRewards,
      dailyCompoundBonus,
      farmerCompoundCount,
      lastWithdrawTimestamp
    }
  }

}

export const getUserAvailableEarningSoFar = async (address) => {
  const { web3Config } = configs
  let availableEarningInBNB = 0.00
  let availableEarningInUSD = 0.00
  try {

    if (address) {
      const minerContractABI = JSON.parse(web3Config.minerContractABI)
      const minerContractAddress = web3Config.minerContractAddress
      const minerContractInstance = await new window.web3Instance.eth.Contract(minerContractABI, minerContractAddress)
      const userAvailableEarningInWei = await minerContractInstance.methods.getAvailableEarnings(address).call()
      availableEarningInBNB = userAvailableEarningInWei / (10 ** 18)
      const bnbPrice = await getBNBPrice()
      availableEarningInUSD = parseFloat(bnbPrice) * parseFloat(availableEarningInBNB)
      return {
        availableEarningInBNB,
        availableEarningInUSD
      }
    } else {
      return {
        availableEarningInBNB,
        availableEarningInUSD
      }
    }

  } catch (error) {
    console.error("ERROR while fetching user available earning so far ", error)
    return {
      availableEarningInBNB,
      availableEarningInUSD
    }
  }
}

export const getEstimatedDailyYield = async (address) => {
  const { web3Config } = configs
  let estimatedDailyYieldInBNB = 0.00
  let estimatedDailyYieldInUSD = 0.00
  try {

    if (address) {
      const minerContractABI = JSON.parse(web3Config.minerContractABI)
      const minerContractAddress = web3Config.minerContractAddress
      const minerContractInstance = await new window.web3Instance.eth.Contract(minerContractABI, minerContractAddress)
      const userDetails = await getDragonDetailsByUserAddress(address)
      const miners = parseFloat(userDetails.miners) || 0.00
      if (miners > 0) {
        const dragonsPerDay = 24 * 60 * 60 * miners
        const estimatedDailyYieldInWei = await minerContractInstance.methods.calculateEggSellForYield(dragonsPerDay, window.web3Instance.utils.toWei('1')).call()
        estimatedDailyYieldInBNB = estimatedDailyYieldInWei / (10 ** 18)
        const bnbPrice = await getBNBPrice()
        estimatedDailyYieldInUSD = parseFloat(estimatedDailyYieldInBNB) * parseFloat(bnbPrice)
        return {
          estimatedDailyYieldInBNB,
          estimatedDailyYieldInUSD
        }
      } else {
        return {
          estimatedDailyYieldInBNB,
          estimatedDailyYieldInUSD
        }
      }
    } else {
      return {
        estimatedDailyYieldInBNB,
        estimatedDailyYieldInUSD
      }
    }

  } catch (error) {
    console.error("ERROR while calculating estimated daily yield ", error)
    return {
      estimatedDailyYieldInBNB,
      estimatedDailyYieldInUSD
    }
  }
}

export const getCompoundSteps = async () => {
  const { web3Config } = configs
  try {
    const minerContractABI = JSON.parse(web3Config.minerContractABI)
    const minerContractAddress = web3Config.minerContractAddress
    const minerContractInstance = await new window.web3Instance.eth.Contract(minerContractABI, minerContractAddress)
    const compoundSteps = await minerContractInstance.methods.COMPOUND_STEP().call()
    return compoundSteps
  } catch (error) {
    console.error("ERROR while fetching compound steps ", error)
    return 0
  }
}

export const getEstimatedMinersFor1BNB = async () => {
  const { web3Config } = configs
  try {
    const minerContractABI = JSON.parse(web3Config.minerContractABI)
    const minerContractAddress = web3Config.minerContractAddress
    const minerContractInstance = await new window.web3Instance.eth.Contract(minerContractABI, minerContractAddress)
    const estimatedMiners = await minerContractInstance.methods.getEggsYield(window.web3Instance.utils.toWei('1')).call()
    return parseInt(estimatedMiners[0])
  } catch (error) {
    console.error("ERROR while fetching estimated miners ", error)
    return 0
  }
}

export const getMaxDepositAmount = async () => {
  const { web3Config } = configs
  try {
    const minerContractABI = JSON.parse(web3Config.minerContractABI)
    const minerContractAddress = web3Config.minerContractAddress
    const minerContractInstance = await new window.web3Instance.eth.Contract(minerContractABI, minerContractAddress)
    const maxDepositAmount = await minerContractInstance.methods.WALLET_DEPOSIT_LIMIT().call()
    return maxDepositAmount / (10 ** 18)
  } catch (error) {
    console.error("ERROR while fetching max deposit amount ", error)
    return 0
  }
}

export const getMinDepositAmount = async () => {
  const { web3Config } = configs
  try {
    const minerContractABI = JSON.parse(web3Config.minerContractABI)
    const minerContractAddress = web3Config.minerContractAddress
    const minerContractInstance = await new window.web3Instance.eth.Contract(minerContractABI, minerContractAddress)
    const minDepositAmount = await minerContractInstance.methods.MIN_INVEST_LIMIT().call()
    return minDepositAmount / (10 ** 18)
  } catch (error) {
    console.error("ERROR while fetching min deposit amount ", error)
    return 0
  }
}

export const getWithdrawalTax = async () => {
  const { web3Config } = configs
  try {
    const minerContractABI = JSON.parse(web3Config.minerContractABI)
    const minerContractAddress = web3Config.minerContractAddress
    const minerContractInstance = await new window.web3Instance.eth.Contract(minerContractABI, minerContractAddress)
    const withdrawalTax = await minerContractInstance.methods.WITHDRAWAL_TAX().call()
    return withdrawalTax / (10)
  } catch (error) {
    console.error("ERROR while fetching withdrawal tax ", error)
    return 0
  }
}

export const getTxCompoundCount = async () => {
  const { web3Config } = configs
  try {
    const minerContractABI = JSON.parse(web3Config.minerContractABI)
    const minerContractAddress = web3Config.minerContractAddress
    const minerContractInstance = await new window.web3Instance.eth.Contract(minerContractABI, minerContractAddress)
    const compoundCount = await minerContractInstance.methods.COMPOUND_FOR_NO_TAX_WITHDRAWAL().call()
    return compoundCount
  } catch (error) {
    console.error("ERROR while fetching compound count ", error)
    return 0
  }
}

export const getCompoundBonus = async () => {
  const { web3Config } = configs
  try {
    const minerContractABI = JSON.parse(web3Config.minerContractABI)
    const minerContractAddress = web3Config.minerContractAddress
    const minerContractInstance = await new window.web3Instance.eth.Contract(minerContractABI, minerContractAddress)
    const compoundBonus = await minerContractInstance.methods.COMPOUND_BONUS().call()
    return compoundBonus / 10
  } catch (error) {
    console.error("ERROR while fetching compound bonus ", error)
    return 0
  }
}

export const hireDragons = async (depositAmount, ref, signer) => {
  const { web3Config } = configs
  const provider = getWeb3PRovider()
  if (provider) {
    const minerContractABI = JSON.parse(web3Config.minerContractABI)
    const minerContractAddress = web3Config.minerContractAddress
    const minerContractInstance = new ethers.Contract(
      minerContractAddress,
      minerContractABI,
      signer
    )

    //convert deposit value into wei
    const depositAmountWei = window.web3Instance.utils.toWei(depositAmount.toString(), 'ether')
    const hireDragonsReceipt = await minerContractInstance.hireDragons(ref, { value: depositAmountWei })
    const result = await hireDragonsReceipt.wait()
    return result
  } else {
    throw Error('Please provide valid web3 provider')
  }
}


export const sellDragons = async (signer) => {
  const { web3Config } = configs
  const provider = getWeb3PRovider()
  if (provider) {
    const minerContractABI = JSON.parse(web3Config.minerContractABI)
    const minerContractAddress = web3Config.minerContractAddress
    const minerContractInstance = new ethers.Contract(
      minerContractAddress,
      minerContractABI,
      signer
    )

    const sellDragonsReceipt = await minerContractInstance.sellDragonEggs()
    const result = await sellDragonsReceipt.wait()
    return result
  } else {
    throw Error('Please provide valid web3 provider')
  }
}

export const hireMoreDragons = async (signer) => {
  const { web3Config } = configs
  const provider = getWeb3PRovider()
  if (provider) {
    const minerContractABI = JSON.parse(web3Config.minerContractABI)
    const minerContractAddress = web3Config.minerContractAddress
    const minerContractInstance = new ethers.Contract(
      minerContractAddress,
      minerContractABI,
      signer
    )

    const hireMoreDragonsReceipt = await minerContractInstance.hireMoreDragons('true')
    const result = await hireMoreDragonsReceipt.wait()
    return result
  } else {
    throw Error('Please provide valid web3 provider')
  }
}

export const getWithdrawalCoolDownTime = async () => {
  const { web3Config } = configs
  try {
    const minerContractABI = JSON.parse(web3Config.minerContractABI)
    const minerContractAddress = web3Config.minerContractAddress
    const minerContractInstance = await new window.web3Instance.eth.Contract(minerContractABI, minerContractAddress)
    const withdrawalCoolDown = await minerContractInstance.methods.WITHDRAW_COOLDOWN().call()
    return withdrawalCoolDown
  } catch (error) {
    console.error("ERROR while fetching withdrawal cool down ", error)
    return 0
  }
}


export const getReferralFee = async () => {
  const { web3Config } = configs
  try {
    const minerContractABI = JSON.parse(web3Config.minerContractABI)
    const minerContractAddress = web3Config.minerContractAddress
    const minerContractInstance = await new window.web3Instance.eth.Contract(minerContractABI, minerContractAddress)
    const referralFee = await minerContractInstance.methods.REFERRAL().call()
    return referralFee / (10)
  } catch (error) {
    console.error("ERROR while fetching referral fee ", error)
    return 0
  }
}

export const getDevFee = async () => {
  const { web3Config } = configs
  try {
    const minerContractABI = JSON.parse(web3Config.minerContractABI)
    const minerContractAddress = web3Config.minerContractAddress
    const minerContractInstance = await new window.web3Instance.eth.Contract(minerContractABI, minerContractAddress)
    const devFee = await minerContractInstance.methods.TAX().call()
    return devFee / (10)
  } catch (error) {
    console.error("ERROR while fetching dev fee ", error)
    return 0
  }
}

export const getNFTPriceByCategoryInBUSD = async (category) => {
  const { nft } = configs
  let nftPriceInBUSD = 0.0
  try {
    const nftMinterContractABI = JSON.parse(nft.contractABI)
    const nftMinterContractAddress = nft.contractAddress
    const nftMinterContractInstance = await new window.web3Instance.eth.Contract(nftMinterContractABI, nftMinterContractAddress)

    if (category === 'normal') {
      const normalFee = await nftMinterContractInstance.methods.normalFeeRate().call()

      nftPriceInBUSD = parseInt(normalFee) / 10 ** 18
    }
    if (category === 'rare') {
      const normalFee = await nftMinterContractInstance.methods.rareFeeRate().call()
      nftPriceInBUSD = parseInt(normalFee) / 10 ** 18
    }
    if (category === 'epic') {
      const normalFee = await nftMinterContractInstance.methods.epicFeeRate().call()
      nftPriceInBUSD = parseInt(normalFee) / 10 ** 18
    }
    return nftPriceInBUSD
  } catch (error) {
    console.error("ERROR while fetching nft category fee ", error)
    return nftPriceInBUSD
  }
}

export const approveBUSDForMinting = async (busdAmount, signer) => {
  const { web3Config, nft } = configs
  const provider = getWeb3PRovider()
  if (provider) {
    const erc20ContractABI = JSON.parse(web3Config.mainContractAbi)
    const busdTokenAddress = web3Config.pricingAddress.busdTokenAddress
    const erc20ContractInstance = new ethers.Contract(busdTokenAddress, erc20ContractABI, signer)

    // //convert deposit value into wei
    const busdForApprovalInWei = window.web3Instance.utils.toWei(busdAmount.toString(), 'ether')
    const spenderAddress = nft.contractAddress
    const approvalReceipt = await erc20ContractInstance.approve(spenderAddress, busdForApprovalInWei)
    const result = await approvalReceipt.wait()
    return result
  } else {
    throw Error('Please provide valid web3 provider')
  }
}

export const mintYourNFT = async (tokenMetadata, metaDataBaseURI, account, signer) => {
  const { nft } = configs
  const provider = getWeb3PRovider()
  if (provider) {
    const nftMintingContractABI = JSON.parse(nft.contractABI)
    const nftContractAddress = nft.contractAddress
    const nftMintingContractInstance = new ethers.Contract(nftContractAddress, nftMintingContractABI, signer)
    const metaDataURI = `${metaDataBaseURI}${tokenMetadata?.id}.json`
    const mintNFTReceipt = await nftMintingContractInstance.safeMint(account, metaDataURI, tokenMetadata?.id, {
      gasLimit: nft.estimatedGasFeeLimit.toString()
    })

    const result = await mintNFTReceipt.wait()
    return result
  } else {
    throw Error('Please provide valid web3 provider')
  }
}

export const isWalletAddressWhiteListedByCategory = async (category, walletAddress) => {
  const { nft } = configs
  let isWhiteListed = false
  try {
    const nftMinterContractABI = JSON.parse(nft.contractABI)
    const nftMinterContractAddress = nft.contractAddress
    const nftMinterContractInstance = await new window.web3Instance.eth.Contract(nftMinterContractABI, nftMinterContractAddress)

    if (category === 'normal') {
      isWhiteListed = await nftMinterContractInstance.methods.isWhitelistedNormal(walletAddress).call()
    }
    if (category === 'rare') {
      isWhiteListed = await nftMinterContractInstance.methods.isWhitelistedRare(walletAddress).call()
    }
    if (category === 'epic') {
      isWhiteListed = await nftMinterContractInstance.methods.isWhitelistedEpic(walletAddress).call()
    }
    return isWhiteListed
  } catch (error) {
    console.error("ERROR while fetching whitelisted data ", error)
    return isWhiteListed
  }
}

export const getSoldStatusByNFTTokenID = async (tokenID) => {
  const { nft } = configs
  let isSold = false
  try {
    const nftMinterContractABI = JSON.parse(nft.contractABI)
    const nftMinterContractAddress = nft.contractAddress
    const nftMinterContractInstance = await new window.web3Instance.eth.Contract(nftMinterContractABI, nftMinterContractAddress)
    isSold = await nftMinterContractInstance.methods.isMinted(tokenID).call()
    return isSold
  } catch (error) {
    console.error("ERROR while fetching minted status of a NFT token ID ", error)
    return isSold
  }
}